<template>
  <div
    :id="name"
    class="text-left absolute w-full bg-white border-r border-l border-t z-10"
  >
    <div class="absolute right-0 p-2" v-on:click="closeMenu">
      <Zondicon class="nav-icon w-4 cursor-pointer fill-current" icon="Close" />
    </div>

    <div
      class="cursor-pointer border-b px-3 py-2 block font-bold"
      v-if="isNoteOrBook"
      v-on:click="getNotes(null)"
    >
      View all
    </div>

    <div
      :key="note.id"
      class="cursor-pointer border-b"
      v-for="note in notes"
      v-on:click="handleClick"
    >
      <router-link
          :to="{ path: `/admin/notes?book=${note.id}` }"
          class="px-3 py-2 block"
          v-if="note.is_book"
      >
        <span v-html="note.title"></span>
      </router-link>
      <dropdown-note-link
          :note="note"
          v-else
      />
    </div>
  </div>
</template>

<script>
import DropdownNoteLink from "./DropdownNoteLink";

export default {
  props: ["closeMenu", "getNotes", "notes", "name"],
  components: {
    DropdownNoteLink
  },
  mounted() {
    // If the user clicks outside of the recent-notes, close the suggestions
    let searchBoxArea = document.getElementById(this.name);
    searchBoxArea.addEventListener("click", this.handleInsideClick);
    document.body.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    handleClick() {
      this.closeMenu();
    },
    handleOutsideClick() {
      const closeOthers = false;
      this.closeMenu(closeOthers);
    },
    handleInsideClick(e) {
      e.stopPropagation(); // this will stop propagation of this event to upper level
    }
  },

  computed: {
    isNoteOrBook() {
      return this.$route.query.book || this.$route.params.note;
    }
  }
};
</script>
